export const ALL_TYPE = 'All';
export const CALENDAR_TYPE = 'Calendar';
export const SIGNAL_TYPE = 'Signal';

export const GTEMPLATE_REMINDER_TYPES = [ALL_TYPE, CALENDAR_TYPE, SIGNAL_TYPE];

export const ALL_TYPE_LABEL = 'Whichever Comes First';
export const CALENDAR_TYPE_LABEL = 'Time Based';
export const SIGNAL_TYPE_LABEL = 'Condition Based';

export const REMINDER_TYPE_DISPLAY_MAP = new Map([
  [ALL_TYPE, ALL_TYPE_LABEL],
  [CALENDAR_TYPE, CALENDAR_TYPE],
  [SIGNAL_TYPE, SIGNAL_TYPE],
]);

export const REMINDER_TYPE_OPTIONS = [
  { label: ALL_TYPE_LABEL, value: ALL_TYPE },
  { label: CALENDAR_TYPE_LABEL, value: CALENDAR_TYPE },
  { label: SIGNAL_TYPE_LABEL, value: SIGNAL_TYPE },
];

export const ONE_TIME_REMINDER_LABEL = 'One-Time';
export const RECURRING_REMINDER_LABEL = 'Recurring';

export const REMINDER_CYCLE_OPTIONS = [
  { label: RECURRING_REMINDER_LABEL, value: true },
  { label: ONE_TIME_REMINDER_LABEL, value: false },
];

export const CAN0_LABEL = 'can0';
export const CAN0 = 'can0';
export const CAN1_LABEL = 'can1';
export const CAN1 = 'can1';
export const CAN2_LABEL = 'can2';
export const CAN2 = 'can2';
export const CAN3_LABEL = 'can3';
export const CAN3 = 'can3';
export const CAN_BUS_OPTIONS = [
  { label: CAN0_LABEL, value: CAN0 },
  { label: CAN1_LABEL, value: CAN1 },
  { label: CAN2_LABEL, value: CAN2 },
  { label: CAN3_LABEL, value: CAN3 },
];

export const CALENDAR_TYPE_UNITS_MAP = new Map([
  ['d', 'Day(s)'],
  ['w', 'Week(s)'],
  ['m', 'Month(s)'],
  ['y', 'Year(s)'],
]);

export const CALENDAR_TYPE_UNITS_TO_DURATION_MAP = new Map([
  ['d', 'days'],
  ['w', 'weeks'],
  ['m', 'months'],
  ['y', 'years'],
]);
